import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Download a ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("sample")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" to see an example of the format required. ")
const _hoisted_4 = { class: "dialog-footer" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UploadFiles = _resolveComponent("UploadFiles")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    "destroy-on-close": "",
    title: _ctx.title ?? 'Import Dialog',
    width: "40%"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("span", _hoisted_4, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSubmit()))
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _withDirectives(_createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_UploadFiles, {
                onOnChangeFiles: _ctx.onChangeFiles,
                multiple: _ctx.multiple,
                accept: _ctx.accept
              }, null, 8, ["onOnChangeFiles", "multiple", "accept"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, null, {
            default: _withCtx(() => [
              _hoisted_1,
              _createVNode(_component_el_link, {
                href: _ctx.template,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["href"]),
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512), [
        [_directive_loading, _ctx.state.isLoading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}